<template>
    <div>
        <v-select :clearable="false" :options="estates" :value="selectValue(selected)" @input="(val) => estateChange(val)" :disabled="disabled"></v-select>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import Estates from './States'

export default {
    props : {
        selected : {
            required : false
        },
        disabled: Boolean
    },

    components : {
        'v-select' : vSelect
    },

    data () {
        return {
            estates : Estates.getEstates()
        }
    },

    methods : {
        estateChange (val) {
            this.selectValue(val.code)
            this.$emit('change', val.code)
        },

        selectValue (value) {
            let selected = '';
            this.estates.forEach((k) => {
                if(k.code == value) {
                    selected = k
                    return
                }
            })

            return selected
        }
    }
}
</script>